import { select, takeLatest } from 'redux-saga/effects'
import { QuickActionsConstants } from '../store/quickActions.constants'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getCurrentDate, getCurrentTime } from '../../../utilities'
import { getIntubationSelector } from '../../intubation/selectors'

export function* setUpdatedQuickActionButton() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { selectedQuickActionButton } = quickActionsObject
  const intubationState = yield select(getIntubationSelector)
  const { key } = intubationState
  let time: string | Date = new Date()
  time = getCurrentTime()
  selectedQuickActionButton.props.savedTime = Date.now()
  selectedQuickActionButton.props.currentDate = getCurrentDate()
  selectedQuickActionButton.props.savedTimeString = time
  selectedQuickActionButton.props.count += 1
  if (selectedQuickActionButton.props.count === selectedQuickActionButton.maxTimes) {
    selectedQuickActionButton.props.disabled = true
    selectedQuickActionButton.props.color = 'grey'
  }
  if (selectedQuickActionButton.procName === 'Intubation') {
    selectedQuickActionButton.key = key
  }
}
export function* setUpdatedQuickActionButtonSaga() {
  yield takeLatest([QuickActionsConstants.SET_SELECTED_QUICK_ACTION_BUTTON], setUpdatedQuickActionButton)
}
